import { assignRotateVars } from './inc/helpers.js';

const ARCHIVE_IDS = ['blog-archive', 'itinerary-archive', 'mt-entry-archive', 'press-archive'];

// htmx is loaded after app.js via Craft's endBody(), so listen on document now.
document.addEventListener('htmx:load', setHtmxDefaults, { once: true });
document.addEventListener('htmx:afterSettle', onArchiveSettle);


export function archive() {
    ARCHIVE_IDS.forEach(id => {
        const $archive = document.getElementById(id);
        if (!$archive) return;

        const $filterToggle = $archive.querySelector('.js-archive-filters-btn');
        const $filterReset = $archive.querySelector('.archive-controls__form-reset');

        $filterToggle?.addEventListener('click', handleFilterToggle);
        $filterReset?.addEventListener('click', (event) => handleFilterReset(event, $archive));
    });
}


function setHtmxDefaults() {
    if (!window.htmx) return;

    htmx.config.defaultFocusScroll = false;
    htmx.config.scrollIntoViewOnBoost = false;
}


function handleFilterReset(e, $archive) {
    e.preventDefault();

    const $form = $archive.querySelector('.archive-controls__form');
    if (!$form) return;

    const $term = $form.querySelector('#archive-search');
    const $allCat = $form.querySelector('input[name="cat"][value=""]');

    if ($term) $term.value = '';
    if ($allCat) $allCat.checked = true;

    $form.querySelectorAll('select').forEach($select => {
        $select.value = '';
    });

    if (window.htmx) {
        htmx.trigger($form, 'submit');
        return;
    }

    $form.requestSubmit();
}


function handleFilterToggle(e) {
    e.preventDefault();
    const $thisBtn = e.currentTarget;
    const $controlsElement = $thisBtn.closest('.archive-controls');
    if (!$controlsElement) return;

    if ( $controlsElement.classList.contains('active') ) {
        $controlsElement.classList.remove('active');
        $thisBtn.setAttribute('aria-expanded', 'false');
    } else {
        $controlsElement.classList.add('active');
        $thisBtn.setAttribute('aria-expanded', 'true');
    }
}


function onArchiveSettle(event) {
    const $target = event.target;
    if ( !($target instanceof Element) ) return;
    if ( !ARCHIVE_IDS.some(id => $target.id === id || $target.closest(`#${id}`)) ) return;

    assignRotateVars('.archive-item__img-wrap');
    assignRotateVars('.archive-link-cards .link-card');
}
